import { render } from "./oidc.vue?vue&type=template&id=d6f7523a&scoped=true"
import script from "./oidc.vue?vue&type=script&lang=js"
export * from "./oidc.vue?vue&type=script&lang=js"

import "./oidc.vue?vue&type=style&index=0&id=d6f7523a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f7523a"]])

export default __exports__